// Deep-link helper: read org context from URL path (/o/:orgId/...) or
// ?org=<orgid> query param. Path takes priority over query param.
//
// Supports shared-link flow where user clicks a link to a resource scoped to
// a non-current organization. If the user is a member of that org, switch
// them to it automatically.
import { extractOrgFromPath } from '@/utils/org-path';

export const ORG_PARAM = 'org';

export const readOrgParam = (
  search: string = window.location.search,
): string | null => {
  try {
    // Check URL path first: /o/:orgId/...
    const pathOrg = extractOrgFromPath(window.location.pathname);
    if (pathOrg?.orgId) return pathOrg.orgId;

    // Fallback to ?org= query param (legacy shared links)
    const params = new URLSearchParams(search);
    const value = params.get(ORG_PARAM);
    return value ? value.trim() : null;
  } catch {
    return null;
  }
};

export const stripOrgParamFromUrl = (): void => {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(ORG_PARAM)) return;
    url.searchParams.delete(ORG_PARAM);
    const newUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState(window.history.state, '', newUrl);
  } catch {
    // no-op
  }
};
